import { useCallback } from "react";
import { Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAppAuthState } from "../../hooks/use-app-auth-state";
import { useUserProjects } from "../../hooks/use-user-projects";
import { formatTimestampNoTime } from "../../lib/format-timestamp";
import { TagList } from "../TagList/TagList";
import "./ProjectList.scss";

interface ProjectListProps {}

const ProjectList: React.FC<ProjectListProps> = () => {
  const navigate = useNavigate();
  const { fireUser } = useAppAuthState();
  const { projects, isLoading: isProjectsLoading } = useUserProjects(
    fireUser?.uid,
  );

  const handleNavigateToProject = useCallback(
    (projectId: string) => {
      navigate(`/project/${projectId}`);
    },
    [navigate],
  );

  return (
    <div className="project-list-wrapper">
      <div className="project-list-header">Projects</div>
      {projects.length === 0 && !isProjectsLoading && (
        <Alert variant="warning">You don't have any projects.</Alert>
      )}
      {projects.length > 0 && (
        <div className="project-list">
          {projects.map((project) => (
            <div
              className="project-list-item"
              key={project.id}
              onClick={() => handleNavigateToProject(project.id)}
            >
              <div className="project-list-item-name">{project.name}</div>
              <div className="project-list-item-description">
                {project.description} &middot;{" "}
                {formatTimestampNoTime(project.createdAt)}
                {project.startupStatus && project.startupStatus.length > 0 && (
                  <>
                    {" "}
                    &middot;{" "}
                    <span className="startup-status-list">
                      {project.startupStatus.join(", ")}
                    </span>
                  </>
                )}
                {project.sectors && project.sectors.length > 0 && (
                  <TagList<string>
                    tags={project.sectors}
                    className="project-sectors-list"
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProjectList;
